// extracted by mini-css-extract-plugin
export default {"containerWrapper":"TermsNConditions_containerWrapper__OwjP3","container":"TermsNConditions_container__UQ5SR","title":"TermsNConditions_title__NJDiD"};